import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { editQuizRequested } from 'features/quizzes/actions';

export function* editQuizSaga(action: ReturnType<typeof editQuizRequested>) {
  yield call(SignalingSocket.send, { event: 'editQuiz', data: action.payload });
}
